import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { DirectoryPhoneNumberSearchDto } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";

export class DirectoryPhoneNumber {
    public id: string;
    public number: string;
    public countryId: string;
    public extension: string;

    public constructor(init?: Partial<DirectoryPhoneNumber>) {
        Object.assign(this, init);

        if (!this.id)
            this.id = GuidHelper.NewGuid();
    }

    public static fromSearchDto(dto: DirectoryPhoneNumberSearchDto): DirectoryPhoneNumber {
        return new DirectoryPhoneNumber(dto);
    }
}
